/**
 * Toast Redux Action Types
 */
export const types = Object.freeze({
    SHOW_TOAST: 'toast/SHOW_TOAST',
    DISMISS_TOAST: 'toast/DISMISS_TOAST',
    DISMISS_ALL_TOASTS: 'toast/DISMISS_ALL_TOASTS',
    UPDATE_TOAST: 'toast/UPDATE_TOAST',
});

